import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBilling } from '@mssgme/hooks';

import styles from './styles.scss';

const isToday = (compareDate) => {
    const today = new Date();

    return (
        compareDate.getDate() >= today.getDate() &&
        compareDate.getMonth() >= today.getMonth() &&
        compareDate.getFullYear() >= today.getFullYear()
    );
};

export default function FreeBanner() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const { plan, trialEndedAt, isUnpaid, isTrial } = useBilling();
    const path = isUnpaid ? '/s/billing/pay' : '/s/billing/plans';

    const bannerTill = new Date('2020-03-09');

    return (
        <>
            {isToday(bannerTill) && i18n.language === 'ru' && (
                <div style={{ color: 'black' }}>
                    <div className={styles.freeBanner}>
                        <h3>
                            Скидка <span style={{ backgroundColor: '#dc5960', borderColor: '#dc5960' }}>30%</span> в
                            честь 8 марта 💐
                        </h3>
                        <p>
                            Используйте промокод{' '}
                            <span
                                style={{
                                    backgroundColor: '#dc5960',
                                    borderColor: '#dc5960',
                                    padding: '1px 3px',
                                    borderRadius: '4px',
                                    marginLeft: '2px',
                                    color: 'white',
                                }}
                            >
                                8march
                            </span>{' '}
                            во время оформления подписки.
                        </p>
                    </div>
                </div>
            )}

            <Link to={{ pathname: path, state: { from: location.pathname } }} style={{ color: 'black' }}>
                <div className={styles.freeBanner}>
                    {isUnpaid ? (
                        <>
                            <h3>{t('NoAccess.unpaid.heading', { plan })}</h3>
                            <p>{t('NoAccess.unpaid.description', { plan })}</p>
                            <span>{t('NoAccess.unpaid.button', { plan })}</span>
                        </>
                    ) : isTrial ? (
                        <>
                            <h3 className={styles.trial}>
                                {t('CardMain.banner.trial')} <span>PRO</span>
                            </h3>
                            <p>{t('CardMain.banner.till', { date: trialEndedAt })}</p>
                            <span className={styles.btn}>{t('CardMain.banner.upgrade')}</span>
                        </>
                    ) : (
                        <>
                            <h3>
                                {t('CardMain.banner.title')} <span>PRO</span>
                            </h3>
                            <p>{t('CardMain.banner.description')}</p>
                            <span>{t('CardMain.banner.link')}</span>
                        </>
                    )}
                </div>
            </Link>
        </>
    );
}
